import { render, staticRenderFns } from "./changepassword.vue?vue&type=template&id=0d1e7196&scoped=true"
import script from "./changepassword.vue?vue&type=script&lang=js"
export * from "./changepassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1e7196",
  null
  
)

export default component.exports